import { UcoastEl } from '@/scripts/core/UcoastEl'

export class NyTimer extends UcoastEl {
    static htmlSelector = 'ny-timer'

    constructor() {
        super()
        this.updateNYTime()
        setInterval(() => this.updateNYTime(), 60000)
    }

    updateNYTime() {
        const options: Intl.DateTimeFormatOptions = {
            timeZone: "America/New_York",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        }

        const formatter = new Intl.DateTimeFormat([], options)
        this.textContent = formatter.format(new Date());
    }
}
